import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { InputExpressionComponent } from './input-expression.component';

@NgModule({
    imports: [TwcModule, FormsModule, CommonModule, TranslateModule, DirectivesModule],
    declarations: [InputExpressionComponent],
    exports: [InputExpressionComponent],
})
export class InputExpressionModule {}
